module.exports = __webpack_public_path__ + "img/kondispatch_success.d748c432.svg";